import type { ImportReport, LegacyImportPlan, ResolvedImport } from "./types";

/**
 * Migration result report.
 *
 * It is intentionally materialized as downloadable JSON: if anything is skipped
 * or cannot be read, the user (or support) has the exact detail row by row,
 * not just a number. Data loss is never summarized as "listo".
 */
export function buildImportReport(
  plan: LegacyImportPlan,
  resolved: ResolvedImport,
  generatedAt: string = new Date().toISOString(),
): ImportReport {
  return {
    sources: plan.sources,
    generatedAt,
    imported: { highlights: resolved.verseHighlights.length },
    preferences: plan.preferences,
    readingPositionApplied: resolved.appliedPreferences !== undefined,
    skipped: resolved.skipped,
    issues: plan.issues,
  };
}

/** Serializes the report to readable JSON for download. */
export function importReportToJson(report: ImportReport): string {
  return JSON.stringify(report, undefined, 2);
}

/** Total number of rows that were NOT written (skipped + with an issue). */
export function reportProblemCount(report: ImportReport): number {
  return report.skipped.length + report.issues.length;
}
